export default function ApiKey(){
    let ApiKeyCode = "652a13cf994dec6d110ce50042bfd5c6"

    return ApiKeyCode;
}